<template>
  <div v-if="familia">

    <div class="row justify-content-center">
      <div class="col-sm-12 col-md-6">
        <div class="card">
          <h5 class="card-header">Renovación de socios</h5>
          <div class="card-body">

            <template v-if="familia.adscripcion == 'socio'">
            <p>
            <b>Adscripción:</b> socio<br />
            <b>Cuota anual:</b> 15 €<br />
            </p>
            <template v-if="! admin">
            <p>Al renovar la subscripción de socios tendréis acceso a todos los servicios y actividades del AMPA durante el presente curso escolar.</p>
            <p>La cuota se cargará en la cuenta de la familia, y se cobrará en el siguiente recibo domiciliado.</p>
            </template>
            </template>

            <template v-else-if="familia.adscripcion == 'exsocio'">
            <p>
            <b>Adscripción:</b> exsocio<br />
            <b>Cuota anual:</b> 0 €<br />
            </p>
            <template v-if="! admin">
            <p>Habéis sido clasificados como <b>exsocios</b> porque, según nuestros datos, no hay ningún alumno cursando en el colegio, habiendo pasado todos a condición de exalumnos.</p>
            <p>Si bien ya no podéis ser socios de la asociación (y por tanto ya no pagáis cuota de socios), podéis permanecer como exsocios, lo que os permite disfrutar de las actividades disponibles para exalumnos.</p>
            </template>
            </template>

            <p>
            <button type="button" class="btn btn-primary" @click="renovar">Renovar</button>
            </p>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { api } from '../api/api.js';

export default {
	name: 'SociosRenovar',
	props: [ 'admin', 'id_familia' ],
	data () {
		return {
			familia: null,
		}
	},
	created () {
		this.obtenerFamilia();
	},
	methods: {
		obtenerFamilia() {
			const id_familia = this.id_familia ? this.id_familia : this.$parent.sesion.id_familia;
			api(`/familias/${id_familia}`)
				.then((data) => {
					if (data.resultado) {
						this.familia = data.resultado;
						console.log(this.familia);
					}
				})
				.catch((error) => {
					console.log(error);
					//this.mensaje_error = error;
				});
		},
		renovar() {
			api(`/familias/${this.familia.id}/renovacion`, 'POST')
				.then((data) => {
					if (data.resultado) {
						if (this.admin) {
							this.$router.push(`/admin/familia/${this.familia.id}`);
						} else {
							this.$router.push('/');
						}
					}
				})
				.catch((error) => {
					console.log(error);
					//this.mensaje_error = error;
				});
		},
	}
}
</script>
